import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '../Alert';

const _Snackbar = () => {
  const dispatch = useDispatch();

  const { snackbarOpen, snackbarMessage, snackBarSeverity } = useSelector((state: any) => state.util);

  const SlideTransition = (props: any) => {
    return <Slide {...props} direction="down" />;
  };

  const handleClose = () => {
    dispatch.util.sendAlert({ snackbarMessage: '', snackbarOpen: false, snackBarSeverity: 'info' });
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      open={snackbarOpen}
      onClose={handleClose}
      autoHideDuration={6000}
      key={snackbarMessage}
      TransitionComponent={SlideTransition}
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    >
      <div>
        <Alert
          onClose={handleClose}
          severity={snackBarSeverity}
          color={snackBarSeverity}
          message={snackbarMessage}
        />
      </div>
    </Snackbar>
  );
};

export default _Snackbar;
